// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"70px","logo-container":"styles_logo-container__28YvR","logoContainer":"styles_logo-container__28YvR"};